import { Reveal } from "./Reveal";

const PROBLEMS = [
  {
    num: "01",
    title: "Context",
    body: "Critical deal insights disappear within hours or stay trapped in people's heads. The nuances that win deals are the first to fade.",
  },
  {
    num: "02",
    title: "Data",
    body: "Raw calls and notes are noisy and unstructured. AI systems and teams receive low-signal input that degrades decisions and agent performance.",
  },
  {
    num: "03",
    title: "Retention",
    body: "Most tools create more work instead of reducing it. Knowledge never compounds — it resets with every new tool, hire, or forgotten conversation.",
  },
];

export const Problems = () => (
  <section id="problems" className="relative py-12 md:py-20" data-testid="problems-section">
    <div className="mx-auto max-w-[1240px] px-6 md:px-12">
      <Reveal>
        <p className="text-sm font-medium tracking-widest uppercase text-teal mb-5">The problem</p>
        <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-50 max-w-3xl leading-[1.08]">
          Three problems every sales organization feels
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.12}>
            <div
              className="group relative h-full rounded-2xl border border-white/[0.07] bg-navy-surface p-8 md:p-9 shadow-[0_8px_32px_rgba(0,0,0,0.18)] transition-all duration-500 hover:border-teal/30 hover:-translate-y-1"
              data-testid={`problem-card-${p.num}`}
            >
              <span className="font-heading text-6xl font-bold text-slate-700/50 transition-colors duration-500 group-hover:text-teal/30">
                {p.num}
              </span>
              <h3 className="mt-6 font-heading text-2xl font-medium text-slate-100">{p.title}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-400">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
